/**
 * Client helper for per-club beta features (SuperAdmin toggles).
 */
import { apiFetch } from './api';

let cached = null;
let inflight = null;

export async function fetchClubBetaFeatures() {
    if (cached) return cached;
    if (inflight) return inflight;

    inflight = apiFetch('/api/club/beta-features')
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
            cached = {
                enabled: data?.enabled || {},
                catalog: data?.catalog || []
            };
            return cached;
        })
        .catch((err) => {
            console.warn('Beta features fetch failed:', err);
            return { enabled: {}, catalog: [] };
        })
        .finally(() => {
            inflight = null;
        });

    return inflight;
}

/** Clear cache after SuperAdmin toggles (optional; page reload also clears) */
export function clearBetaFeaturesCache() {
    cached = null;
}

export function isBetaEnabled(features, featureId) {
    return !!features?.enabled?.[featureId];
}
